module.exports = __webpack_public_path__ + "img/00005.cea9fb84.webp";